import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { BackButton } from '@/shared/ui/Icons'
import { SxProps } from '@mui/system'
import { Theme } from '@mui/material/styles'

type ContainerType = HTMLElement | { current: HTMLElement | null } | null

interface ScrollToTopButtonProps {
    handleOnClick: () => void
    container: ContainerType
    style?: SxProps<Theme>
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({
    handleOnClick,
    container,
    style,
}) => {
    const [scrollTop, setScrollTop] = useState(0)
    let containerRef: HTMLElement | null = null

    if (container && 'current' in container) {
        containerRef = container.current
    } else {
        containerRef = container as HTMLElement | null
    }

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef) {
                setScrollTop(containerRef.scrollTop || 0)
            }
        }

        if (containerRef) {
            containerRef.addEventListener('scroll', handleScroll)
            return () => {
                containerRef?.removeEventListener('scroll', handleScroll)
            }
        }
    }, [containerRef])

    const arrowButtonStyles: SxProps<Theme> = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        bottom: '20px',
        right: '50px',
        borderRadius: '50%',
        zIndex: 9,
        '&:hover': {
            cursor: 'pointer',
        },
        transform: 'rotate(90deg)',
        opacity: scrollTop > 1000 ? 1 : 0,
        transition: 'opacity 0.5s ease-out',
        ...(style || {}),
    }

    return (
        <Box sx={arrowButtonStyles} onClick={handleOnClick}>
            <BackButton />
        </Box>
    )
}

export default ScrollToTopButton
